module.exports = __webpack_public_path__ + "static/media/CAPS.f39d6965.svg";